import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config";
import axios from "axios";

// picked rate request
export const fetchLeadStatusRequest = () => ({
    type: "FIND_LEAD_STATUS_REQUEST",
});

export const fetchLeadStatusSuccess = (data) => ({
    type: "FIND_LEAD_STATUS_SUCCESS",
    payload: data,
});

export const fetchLeadStatusFailure = (error) => ({
    type: "FIND_LEAD_STATUS_FAILURE",
    payload: error,
});

export const getLeadStatus = (token, user_id, filter_by, current_page, queryParams,picked_user_id) => {

    return async function (dispatch) {
        dispatch(fetchLeadStatusRequest());

        let params = new URLSearchParams(queryParams);
        let requestBody = {
            destination: "",
            email: "",
            end_date: null,
            name: "",
            origin: "",
            phone: "",
            request_no: "",
            required_servie_id: "",
            search_by: "",
            shipment_type_id: "",
            shipment_via_id: "",
            start_date: null,
        };
        params.forEach((value, key) => {
            requestBody[key] = value;
        });

        if (filter_by == "all") { requestBody.filter_by = "all" }
        if (filter_by == "picked") { requestBody.filter_by = "2" }
        if (filter_by == "send-for-pricing") { requestBody.filter_by = "3" }
        if (filter_by == "price-received") { requestBody.filter_by = "4" }
        if (filter_by == "price-viewed") { requestBody.filter_by = "5" }
        if (filter_by == "repricing") { requestBody.filter_by = "9" }
        if (filter_by == "quotation-sent") { requestBody.filter_by = "6" }
        if (filter_by == "converted") { requestBody.filter_by = "7" }
        if (filter_by == "not-converted") { requestBody.filter_by = "8" }

        params.delete('page');  // Remove the page from the query params
        
        let apiUrl = `${adminMainUrl}/api/quotation/list?page=${current_page}`
        if(picked_user_id){
            requestBody.picked_user_id = picked_user_id
            apiUrl = `${adminMainUrl}/api/quotation/list-by-user?page=${current_page}`
        }

        let config = {
            method: "POST",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        };
        if (!current_page) {
            current_page = 1;
        }


        

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchLeadStatusSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getLeadStatus function(redux):", err);
                fetchLeadStatusFailure(err.message);
            });
    };
};

// picked rate request


//get Quotation/Lead Info

export const fetchQuoteDetailRequest = () => ({
    type: "FIND_QUOTE_DETAIL_REQUEST",
});

export const fetchQuoteDetailSuccess = (data) => ({
    type: "FIND_QUOTE_DETAIL_SUCCESS",
    payload: data,
});

export const fetchQuoteDetailFailure = (error) => ({
    type: "FIND_QUOTE_DETAIL_FAILURE",
    payload: error,
});

export const getQuoteDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchQuoteDetailRequest());
        let config = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'auth-token': token,
                'user_id': user_id
            },
            body: JSON.stringify({ quotation_id: id })
        };
        await fetch(`${adminMainUrl}/api/quotation/view`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchQuoteDetailSuccess(resData.data));
                })
            }).catch((err) => {
                dispatch(fetchQuoteDetailFailure(err.message));
                console.log("ERROR in getQuoteDetail function(redux):", err);
            });
    };
};


//get Quotation/Lead Info


//get Pricing Quotation/Lead Info

export const fetchPricingQuoteDetailRequest = () => ({
    type: "FIND_PRICING_QUOTE_DETAIL_REQUEST",
});

export const fetchPricingQuoteDetailSuccess = (data) => ({
    type: "FIND_PRICING_QUOTE_DETAIL_SUCCESS",
    payload: data,
});

export const fetchPricingQuoteDetailFailure = (error) => ({
    type: "FIND_PRICING_QUOTE_DETAIL_FAILURE",
    payload: error,
});

export const getPricingQuoteDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchPricingQuoteDetailRequest());
        let config = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'auth-token': token,
                'user_id': user_id,
            },
            body: JSON.stringify({ quotation_id: id })
        };
        await fetch(`${adminMainUrl}/api/pricing/view`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchPricingQuoteDetailSuccess(resData.data));
                })
            }).catch((err) => {
                dispatch(fetchPricingQuoteDetailFailure(err.message));
                console.log("ERROR in getPricingQuoteDetail function(redux):", err);
            });
    };
};


//get Pricing Quotation/Lead Info



// // Job Order List

// export const fetchJobOrderListCCRequest = () => ({
//     type: "FIND_JOB_ORDER_LIST_CC_REQUEST",
// });

// export const fetchJobOrderListCCSuccess = (data) => ({
//     type: "FIND_JOB_ORDER_LIST_CC_SUCCESS",
//     payload: data,
// });

// export const fetchJobOrderListCCFailure = (error) => ({
//     type: "FIND_JOB_ORDER_LIST_CC_FAILURE",
//     payload: error,
// });

// // export const getJobOrderListCC = (token, user_id, current_page, queryParams) => {

// //     return async function (dispatch) {
// //         dispatch(fetchJobOrderListCCRequest());
// //         let params = new URLSearchParams(queryParams);
// //         let requestBody = {
            
// //         };
// //         params.forEach((value, key) => {
// //             requestBody[key] = value;
// //         });


// //         params.delete('page'); 

// //         let config = {
// //             method: "GET",
// //             headers: {
// //                 'auth-token': token,
// //                 'user_id': user_id,
// //                 'Content-Type': 'application/json',
// //             },
// //             body: JSON.stringify(requestBody)
// //         };
// //         if (!current_page) {
// //             current_page = 1;
// //         }


// //         let apiUrl = `${adminMainUrl}/api/jobOrder/list?page=${current_page}`

// //         await fetch(apiUrl, config)
// //             .then((res) => {
// //                 res.json().then((resData) => {
// //                     dispatch(fetchJobOrderListCCSuccess(resData));
// //                 });
// //             }).catch((err) => {
// //                 console.log("ERROR in getLeadStatus function(redux):", err);
// //                 fetchJobOrderListCCFailure(err.message);
// //             });
// //     };
// // };


// export const getJobOrderListCC = (token, user_id, current_page = 1, queryParams = {}) => {
//     return async function (dispatch) {
//         // Dispatch the request action
//         dispatch(fetchJobOrderListCCRequest());

//         // Construct query parameters for the URL
//         const params = new URLSearchParams(queryParams);
//         params.delete('page'); // Ensure 'page' isn't duplicated in the query string

//         // Build the API URL with the current page and additional query parameters
//         const apiUrl = `${adminMainUrl}/api/customClearance/list?page=${current_page}&${params.toString()}`;

//         // Configuration for the fetch request
//         const config = {
//             method: "GET",
//             headers: {
//                 'auth-token': token,
//                 'user_id': user_id,
//                 'Content-Type': 'application/json',
//             },
//         };

//         try {
//             // Make the API call
//             const response = await fetch(apiUrl, config);

//             // Check for HTTP errors
//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             // Parse the JSON response
//             const data = await response.json();

//             // Log the response data for debugging
//             // console.log("Response Data:", data);

//             // Dispatch the success action with response data
//             dispatch(fetchJobOrderListCCSuccess(data));
//         } catch (error) {
//             // Log and dispatch the failure action
//             console.error("ERROR in getJobOrderListCC function (redux):", error);
//             dispatch(fetchJobOrderListCCFailure(error.message));
//         }
//     };
// };

// Downline user list
export const getDownlineUser = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_DOWNLINE_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/downline-list`;
        // let body = { id: country_id }
        try {
            axios(apiUrl,config).then((res) => {
                dispatch({
                    type: "FIND_DOWNLINE_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getDownlineUser function (redux):", err);
                dispatch({
                    type: "FIND_DOWNLINE_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getDownlineUser function:", error);
            dispatch({
                type: "FIND_DOWNLINE_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
